/**
 * SearchIcon — sanitized from `assets/newSvg/search.svg`.
 * Artboard: 1024×1024 · viewBox 0 0 24 24 (fixed).
 */
import React from 'react';
import Svg, { Path } from 'react-native-svg';
import {
  APP_ICON_VIEW_BOX,
  useAppIconProps,
  type AppIconProps,
} from './iconBase';

export function SearchIcon(props: AppIconProps) {
  const { size, color, style, accessibilityLabel, testID, ...rest } = useAppIconProps(props);

  return (
    <Svg
      width={size}
      height={size}
      viewBox={APP_ICON_VIEW_BOX}
      style={style}
      accessibilityLabel={accessibilityLabel}
      testID={testID}
      {...rest}
    >
      <Path
        d="M5.5,10 C5.5,7.51472 7.51472,5.5 10,5.5 C12.4853,5.5 14.5,7.51472 14.5,10 C14.5,12.4853 12.4853,14.5 10,14.5 C7.51472,14.5 5.5,12.4853 5.5,10 Z M10,2.5 C5.85786,2.5 2.5,5.85786 2.5,10 C2.5,14.1421 5.85786,17.5 10,17.5 C11.5286,17.5 12.9504,17.0427 14.1361,16.2574 L18.9393,21.0607 C19.5251,21.6464 20.4749,21.6464 21.0607,21.0607 C21.6464,20.4749 21.6464,19.5251 21.0607,18.9393 L16.2574,14.1361 C17.0427,12.9504 17.5,11.5286 17.5,10 C17.5,5.85786 14.1421,2.5 10,2.5 Z"
        fill={color}
      />
    </Svg>
  );
}

export default SearchIcon;
